export default __webpack_public_path__ + "static/media/organic_203.057afc5c.jpg";